export default __webpack_public_path__ + "static/media/iconAntiFraudInfo.f1920268.svg";